import { Fragment, useEffect } from 'react'
import Image from 'next/image'
import { trackGoal } from 'fathom-client'
import { Tweet } from 'react-twitter-widgets'

import Pinterest from 'components/social/pinterest'
import ShopBlock from './shopBlock'

export default function articleContent({ blocks, completeSlug }) {
  return blocks.map((thisBlock) => (
    <Artcileblock
      key={blocks.order}
      name={thisBlock.name}
      attributes={thisBlock.attributes}
      innerBlocks={thisBlock.innerBlocks}
      completeSlug={completeSlug}
    />
  ))
}

const Artcileblock = ({ name, attributes, innerBlocks, completeSlug }) => {
  switch (name) {
    case 'core/columns': {
      return (
        <div className="flex flex-col md:flex-row md:justify-between md:space-x-4">
          {innerBlocks.map((thisColumn) => (
            <div
              key={thisColumn.order}
              className=""
              style={{ width: thisColumn.attributes.width ? thisColumn.attributes.width : '100%' }}>
              {thisColumn.innerBlocks.map((thisInnerBlock) => (
                <Artcilesimpleblock
                  key={thisInnerBlock.order}
                  name={thisInnerBlock.name}
                  attributes={thisInnerBlock.attributes}
                  completeSlug={completeSlug}
                />
              ))}
            </div>
          ))}
        </div>
      )
    }

    default:
      return <Artcilesimpleblock name={name} attributes={attributes} completeSlug={completeSlug} />
  }
}

const Artcilesimpleblock = ({ name, attributes, completeSlug }) => {
  switch (name) {
    case 'core/paragraph':
      return (
        <p
          className="my-6"
          style={{ textAlign: attributes.align || 'left' }}
          dangerouslySetInnerHTML={{ __html: attributes.content }}
        />
      )

    case 'core/image':
      const BlockImage = (
        <Image
          layout={attributes.layout}
          className=""
          width={attributes.width}
          height={attributes.height}
          alt={attributes.alt}
          src={attributes.url}
        />
      )
      return (
        <figure
          className={`group relative my-6 
          ${attributes.align === 'right' ? 'sm:ml-4' : attributes.align === 'left' ? 'sm:mr-4' : ''}
          `}
          style={{ float: attributes.align }}>
          <a
            href={`http://pinterest.com/pin/create/button/?url=${encodeURI(completeSlug)}&media=${encodeURI(
              attributes.url
            )}&description=${attributes.alt}`}
            onClick={() => trackGoal('KEWSAVTU', 0)}
            target="_blank"
            rel="noreferrer noopener"
            title="Enregistrer l'image sur Pinterest"
            className="absolute left-4 top-4 z-10 hidden rounded-full bg-[#E60023] p-1 text-white group-hover:block">
            <Pinterest className="h-5 w-5" />
          </a>
          {attributes.href ? (
            <a href={attributes.href} target="_blank" rel="noopener noreferrer">
              {BlockImage}
            </a>
          ) : (
            BlockImage
          )}

          {attributes.caption && (
            <figcaption
              className={`${
                attributes.layout === 'responsive' ? 'mt-1 text-base' : 'mt-0 text-sm'
              } text-center italic text-gray-700`}
              dangerouslySetInnerHTML={{ __html: attributes.caption }}
            />
          )}
        </figure>
      )

    case 'core/heading': {
      const Heading = `h${parseInt(attributes.level)}`
      return (
        <Heading
          className={`mb-6 mt-12`}
          dangerouslySetInnerHTML={{ __html: attributes.content }}
          style={{ textAlign: attributes.textAlign || 'left' }}></Heading>
        // <Fragment
        //   dangerouslySetInnerHTML={{
        //     __html: `<h${parseInt(attributes.level)} class="mb-6 mt-12" style="text-align: ${
        //       attributes.textAlign || 'left'
        //     };">${attributes.content}</h${parseInt(attributes.level)}>`
        //   }}
        // />
      )
    }

    case 'core/list':
      if (attributes.ordered)
        return (
          <ol
            className="my-6 list-outside list-decimal space-y-2 pl-6"
            start={attributes.start === 0 ? '1' : attributes.start}
            dangerouslySetInnerHTML={{ __html: attributes.values }}
          />
        )
      return (
        <ul
          className="my-6 list-outside list-disc space-y-2 pl-6"
          dangerouslySetInnerHTML={{ __html: attributes.values }}
        />
      )

    case 'core/embed':
      if (attributes.providerNameSlug == 'twitter') {
        return (
          <div className="w-full text-center">
            <Tweet tweetId={attributes.url.split('/status/')[1].split('?')[0]} options={{ align: 'center' }} />
          </div>
        )
      }

      if (attributes.providerNameSlug == 'youtube') {
        return (
          <div className="relative h-0 w-full pb-[56.25%]">
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${attributes.url.replace(
                'https://www.youtube.com/watch?v=',
                ''
              )}`}
              frameBorder="0"
              className="absolute h-full w-full"
            />
          </div>
        )
      }

      return null

    case 'core/quote':
      return (
        <figure className="my-6">
          <blockquote
            className="border-l-2 border-blue-200 py-1 pl-2 italic text-gray-800"
            dangerouslySetInnerHTML={{
              __html: `${attributes.value}<figcaption class=" mt-2 not-italic">— <cite class="not-italic font-medium">${attributes.citation}</cite></figcaption>`
            }}
          />
        </figure>
      )

    case 'core/shortcode':
      if (attributes?.text?.startsWith('[shop ')) {
        return <ShopBlock shortcode={attributes.text} />
      } else {
        return <div className="my-6 text-red-600">Shortcode not available</div>
      }

    default:
      return <CmpNotAvailable name={name} />
  }
}

const CmpNotAvailable = ({ name }) => {
  useEffect(() => {
    console.log(name + ' is not available')
  }, [])

  if (process.env.NODE_ENV !== 'production') {
    return <div className="my-6 text-red-600">{name} is not available</div>
  } else {
    return null
  }
}
